(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-mobile-search-toggle]');
    if (toggle) {
      const header = toggle.closest('header');
      const open = !header.classList.contains('mobile-search-open');
      header.classList.toggle('mobile-search-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      if (open) {
        requestAnimationFrame(() => header.querySelector('.header__search input[type="search"]')?.focus());
      } else {
        header.querySelector('.header__search-close')?.click();
      }
      return;
    }
    if (event.target.closest('.header__search-close, .fixed-overlay--header-section, .menu-drawer-button')) {
      document.querySelectorAll('header.mobile-search-open').forEach((header) => {
        header.classList.remove('mobile-search-open');
        const button = header.querySelector('[data-mobile-search-toggle]');
        button?.setAttribute('aria-expanded', 'false');
        if (event.target.closest('.header__search-close')) button?.focus();
      });
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      document.querySelector('header.mobile-search-open .header__search-close')?.click();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
